import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=32b0d90e&scoped=true&"
import script from "./CustomerContact.vue?vue&type=script&lang=js&"
export * from "./CustomerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0d90e",
  null
  
)

export default component.exports